export default __webpack_public_path__ + "static/media/comment.ee37f30e.png";